/* ==========================================================================
   DIIP COOKIE CONSENT
   ขึ้นทันทีตอนโหลดเว็บ (ถ้ายังไม่เคยเลือกมาก่อน) บังคับให้เลือกอย่างใดอย่าง
   หนึ่งก่อน ไม่มีปุ่ม X ปิด ไม่ปิดเองตอนคลิกพื้นหลัง
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  var popup = document.getElementById('diip-cookie-popup');
  if (!popup) return;

  var STORAGE_KEY = 'diip_cookie_consent'; // เก็บ { necessary:true, analytics:bool, marketing:bool, ts:number }

  function getSavedConsent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function saveConsent(consent) {
    try {
      consent.necessary = true; // จำเป็นเสมอ ปิดไม่ได้
      consent.ts = Date.now();
      localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
    } catch (e) {
      /* เงียบไว้ ถ้าเซฟไม่ได้ (เช่น Private Mode) ก็แค่จะขึ้น Popup ซ้ำอีกครั้งหน้า ไม่กระทบการใช้งานอื่น */
    }

    /*
      DIIP หมายเหตุ: ตรงนี้คือจุดที่ควรต่อกับ Analytics/Marketing script จริง
      ของร้าน (เช่น Google Analytics, Facebook Pixel, TikTok Pixel) — ปกติจะ
      เขียนโค้ดให้ script เหล่านั้น "เช็คค่าใน localStorage ตัวนี้ก่อน" ว่า
      อนุญาตหรือยัง ค่อยยิง Tracking จริง (ทำแยกเป็นงานต่างหาก แจ้งได้ถ้าต้องการ)
    */
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
  }

  function openPopup() {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
  }

  // ถ้าเคยเลือกมาก่อนแล้ว ไม่ต้องขึ้นซ้ำ
  if (!getSavedConsent()) {
    openPopup(); // ขึ้นทันที ไม่มีดีเลย์ ต่างจาก Email Popup
  }

  var mainPanel = popup.querySelector('[data-cookie-panel-main]');
  var settingsPanel = popup.querySelector('[data-cookie-panel-settings]');

  function showSettingsPanel() {
    mainPanel.hidden = true;
    settingsPanel.hidden = false;
  }

  function showMainPanel() {
    settingsPanel.hidden = true;
    mainPanel.hidden = false;
  }

  var openSettingsBtn = popup.querySelector('[data-cookie-open-settings]');
  if (openSettingsBtn) openSettingsBtn.addEventListener('click', showSettingsPanel);

  var backBtn = popup.querySelector('[data-cookie-back]');
  if (backBtn) backBtn.addEventListener('click', showMainPanel);

  // ปุ่ม "ยอมรับและดำเนินการต่อ" — ยอมรับคุกกี้ทุกประเภท
  var acceptAllBtn = popup.querySelector('[data-cookie-accept-all]');
  if (acceptAllBtn) {
    acceptAllBtn.addEventListener('click', function () {
      saveConsent({ analytics: true, marketing: true });
      closePopup();
    });
  }

  // ปุ่ม "ดำเนินการต่อโดยไม่ยอมรับ" — ปฏิเสธคุกกี้ที่ไม่จำเป็นทั้งหมด
  var declineBtn = popup.querySelector('[data-cookie-decline]');
  if (declineBtn) {
    declineBtn.addEventListener('click', function () {
      saveConsent({ analytics: false, marketing: false });
      closePopup();
    });
  }

  // ปุ่ม "บันทึกการตั้งค่า" — บันทึกตามที่ลูกค้าเลือกเองในหน้าตั้งค่า
  var saveSettingsBtn = popup.querySelector('[data-cookie-save-settings]');
  if (saveSettingsBtn) {
    saveSettingsBtn.addEventListener('click', function () {
      var analyticsToggle = popup.querySelector('[data-cookie-toggle="analytics"]');
      var marketingToggle = popup.querySelector('[data-cookie-toggle="marketing"]');
      saveConsent({
        analytics: analyticsToggle ? analyticsToggle.checked : false,
        marketing: marketingToggle ? marketingToggle.checked : false,
      });
      closePopup();
    });
  }
});
